import { render, staticRenderFns } from "./AdminUsersTable.vue?vue&type=template&id=01fd5a70&scoped=true"
import script from "./AdminUsersTable.vue?vue&type=script&lang=js"
export * from "./AdminUsersTable.vue?vue&type=script&lang=js"
import style0 from "./AdminUsersTable.vue?vue&type=style&index=0&id=01fd5a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd5a70",
  null
  
)

export default component.exports